import * as React from 'react';

import { IconFunctionalInformationCircle16, UIHeading1, UIHeading5 } from '@cian/ui-kit';
import * as styles from './styles.css';

interface IProfiMobileLayoutProps extends React.PropsWithChildren {
  onClick: () => void;
}

export const ProfiMobileLayout: React.FC<IProfiMobileLayoutProps> = ({ onClick, children }) => {
  return (
    <section>
      <div className={styles['mobile-container']}>
        <div className={styles['mobile-image']} />

        <div className={styles['mobile-title']}>
          <UIHeading1 as="h2" color="text-primary-default">
            Подберем лучшего в&nbsp;своём деле
          </UIHeading1>
        </div>

        <div className={styles['wrapper']}>{children}</div>

        <div className={styles['mobile-label']} onClick={onClick}>
          <UIHeading5 color="text-on-bright-default">Критерии качества наших агентов </UIHeading5>
          <IconFunctionalInformationCircle16 color="text-on-bright-default"></IconFunctionalInformationCircle16>
        </div>
      </div>
    </section>
  );
};
